import { AppState, Auth0Provider } from '@auth0/auth0-react';
import Auth from '@breville/xps-utils/core/auth';
import { logger } from '@breville/xps-utils/core-ts/logger';
import { appConfig } from '../../utils/appConfig';
import AuthPageComponentWrapper from './AuthPageComponentWrapper';

/**
 * Higher-Order Component that wraps any component with Auth0Provider.
 * Mirrors chefsteps-ui/src/library/hocs/withAuth0/index.tsx.
 *
 * Config is read from src/config/config.{env}.json via appConfig,
 * exactly the same way chefsteps-ui uses publicRuntimeConfig from next.config.js.
 */
const withAuth0 = (PageComponent: any) => {
  const WithAuth0 = (props: { [key: string]: any }) => {
    const {
      domain: auth0Domain,
      issuer: auth0Issuer,
      clientId: auth0ClientId,
      audience: auth0Audience,
      scope: auth0Scope,
      experienceId: auth0ExperienceId,
    } = appConfig.auth0;

    const { shellAppUrl } = appConfig;

    const hasConfiguration =
      auth0Domain &&
      auth0Issuer &&
      auth0ClientId &&
      auth0Audience &&
      auth0Scope &&
      auth0ExperienceId;

    if (typeof window !== 'undefined' && hasConfiguration) {
      Auth.init({
        auth0Domain,
        auth0Issuer,
        auth0ClientId,
        auth0Audience,
        auth0Scope,
        auth0SignupExpid: auth0ExperienceId,
        profileUrl: `${shellAppUrl}/en-us/auth`,
      });
    } else if (typeof window !== 'undefined') {
      logger.error('Auth0 configuration is missing. Skipping Auth0 initialization.');
    }

    if (typeof window !== 'undefined' && hasConfiguration) {
      const authRedirectUri = `${window.location.origin}${window.location.pathname}`;

      return (
        <Auth0Provider
          domain={auth0Domain}
          issuer={auth0Issuer}
          clientId={auth0ClientId}
          redirectUri={authRedirectUri}
          audience={auth0Audience}
          scope={auth0Scope}
          useRefreshTokens={true}
          cacheLocation="localstorage"
          onRedirectCallback={(appState?: AppState) => {
            const forwarding_url = (appState as any)?.forwarding_url;
            if (forwarding_url) {
              window.location.href = forwarding_url;
            }
          }}
        >
          <AuthPageComponentWrapper PageComponent={PageComponent} {...props} />
        </Auth0Provider>
      );
    }

    return <PageComponent {...props} />;
  };

  return WithAuth0;
};

export default withAuth0;
